//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import cmBlank from '@/components/cmBlank.vue'

export default {
  name: 'coupon',
  components: {
    cmBlank
  },
  data () {
    return {
      blankShow:false,
      list:[],
      type:0,
    }
  },
  created(){
  },
  mounted(){
    this.type = Number(this.$route.params.type);
    console.log(this.type);
    this.communityCoupon();
    // this.changePop();
  
  },
  methods:{
    communityCoupon(){
      this.$api.communityCoupon({type:this.type}).then((res)=>{
        if(res){
          if(!this.lastId){
              this.blankShow = res.data.length > 0 ? false : true;
          }
          this.list = res.data;
        } 
      })  
    },
    give(id){
      this.$router.push({name:'giveCoupon',params:{id:id}});
    },
    qrCoupon(id){
      this.$router.push({name:'qrCoupon',params:{id:id}});
    },
  }
}



// WEBPACK FOOTER //
// ./src/pages/coupon.vue